import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { DynamicFormModule } from '@adex/shared/modules/dynamic-form/dynamic-form.module'
import { SharedModule } from '@adex/shared/shared.module'
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzSpinModule } from 'ng-zorro-antd/spin'
import { NzRadioModule } from 'ng-zorro-antd/radio'
import { AuthRoutingModule } from './auth-routing.module'
import { RegisterComponent } from './components/register/register.component'
import { RegisterContainerComponent } from './containers/register-container/register-container.component'
import { AuthMainContainerComponent } from './containers/auth-main-container/auth-main-container.component'
import { TranslateModule } from '@ngx-translate/core'
import { LoginContainerComponent } from './containers/login-container/login-container.component'
import { LoginComponent } from './components/login/login.component'
import {
  ForgotPasswordContainerComponent
} from './containers/forgot-password-container/forgot-password-container.component'
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component'
import { SetPasswordContainerComponent } from './containers/set-password-container/set-password-container.component'
import { SetPasswordComponent } from './components/set-password/set-password.component'
import {
  EmailConfirmationContainerComponent
} from './containers/email-confirmation-container/email-confirmation-container.component'
import { EmailConfirmationComponent } from './components/email-confirmation/email-confirmation.component'
import { ConfirmationContainerComponent } from './containers/confirmation-container/confirmation-container.component'
import { ConfirmationComponent } from './components/confirmation/confirmation.component'
import {
  ForgotPasswordConfirmationContainerComponent
} from './containers/forgot-password-confirmation-container/forgot-password-confirmation-container.component'
import {
  ResetSetPasswordContainerComponent
} from './containers/reset-set-password-container/reset-set-password-container.component'
import { ModelLoaderService } from '@adex/shared/services/model-loader.service'
import { NzInputModule } from 'ng-zorro-antd/input'
import { NzDividerModule } from "ng-zorro-antd/divider";
import { GoogleAuthComponent } from './components/google-auth/google-auth.component';


@NgModule({
  declarations: [
    RegisterComponent,
    RegisterContainerComponent,
    AuthMainContainerComponent,
    LoginContainerComponent,
    LoginComponent,
    ForgotPasswordContainerComponent,
    ForgotPasswordComponent,
    SetPasswordContainerComponent,
    SetPasswordComponent,
    EmailConfirmationContainerComponent,
    EmailConfirmationComponent,
    ConfirmationComponent,
    ConfirmationContainerComponent,
    ForgotPasswordConfirmationContainerComponent,
    ResetSetPasswordContainerComponent,
    GoogleAuthComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    DynamicFormModule,
    NzCheckboxModule,
    NzButtonModule,
    NzIconModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    NzSpinModule,
    NzRadioModule,
    NzInputModule,
    NzDividerModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AuthModule {

  constructor(modelLoader: ModelLoaderService) {
    modelLoader.startPreload([ 'login-form' ])
  }
}
